






















import Vue, { PropType } from 'vue'
import { DocumentNode } from 'graphql'
import {
  ApolloQueryResult,
  QueryOptions,
  OperationVariables,
} from 'apollo-client'
import XCircularProgress from '@/components/atoms/CircularProgress/XCircularProgress.vue'

/**
 * @see https://apollo.vuejs.org/api/apollo-query.html#props
 */
export type GqlQueryProps<V = OperationVariables> = QueryOptions<V> & {
  deep: boolean
  showLoader: boolean
}

type PrivateMethods = {
  ignoreLoading: (isIgnore: boolean) => void
  onDone: (result: ApolloQueryResult<any>) => void
  onLoading: (loading: boolean) => void
}

export type GqlMethods = {
  refetch: () => void
}

export default Vue.extend<{}, GqlMethods, {}, GqlQueryProps>({
  components: { XCircularProgress },
  name: 'GqlQuery',
  props: {
    query: {
      type: Object as PropType<DocumentNode>,
      required: true,
    },
    deep: {
      type: Boolean,
      default: true,
    },
    showLoader: {
      type: Boolean,
      default: true,
    },
    // ...rest (inherits props from apollo-query)
  },
  methods: {
    refetch() {
      const apolloQuery = this.$refs.apolloQuery as any
      apolloQuery.getApolloQuery().refetch()
    },
  },
})
